import { EHttpMethods } from "../../../../enums";
import { CONTRACT_BASE_URL } from "../../../constants";
import { getToken } from "../../../context/authContext";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import {
  MATCH_LOCKER_SHIPMENTS_PATH,
  SETTLE_LOCKER_SHIPMENTS_PATH,
} from "./constants";
import {
  IMatchLockerShipmentsResponse,
  ISettleLockerShipmentsResponse,
} from "./models";

const defaultProvide = async () => await getToken();

/**
 * Uploads the service provider's Excel sheet and returns the locker contracts
 * whose tracking number matched (and are still unsettled), plus the tracking
 * numbers that matched nothing.
 *
 * Not routed through `fetchRequest`: it always sets a JSON Content-Type, and a
 * multipart body needs the browser to set its own boundary header.
 */
export const matchLockerShipments = async (
  file: File
): Promise<IMatchLockerShipmentsResponse> => {
  const url = `${CONTRACT_BASE_URL}${MATCH_LOCKER_SHIPMENTS_PATH}`;
  const body = new FormData();
  body.append("file", file);

  const token = await defaultProvide();
  const headers = new Headers();
  if (token) headers.append("authorization", "Bearer " + token);

  const response = await fetch(url, { method: "POST", headers, body });
  const text = await response.text();
  const json = text ? JSON.parse(text) : {};
  if (!response.ok || json.successful === false || json.error) throw json;
  return json;
};

/** Settles every given locker contract (marks its shipment fee as settled). */
export const settleLockerShipments = (
  contractIds: string[]
): Promise<ISettleLockerShipmentsResponse> => {
  const url = `${CONTRACT_BASE_URL}${SETTLE_LOCKER_SHIPMENTS_PATH}`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.POST,
    defaultProvide
  );
  return fetchRequest(descriptor, { contractIds });
};
